import React, { Component } from 'react';
import WatchlistCustomerComponent from '../detail/WatchlistCustomerComponent';
import { CustomerRequest, SocialMediaStatus, WatchlistCustomerDomains } from '../../../domain/watchlist/WatchlistCustomerDomains';
import WatchlistService from '../../../service/WatchlistService';
import ServiceContainer from '../../../config/ServiceContainer';
import { ServiceNames } from '../../../constant/ServiceNames';
import { FormicaProps, withFormica } from '../../../helpers/withFormica';
import CaseRadialProgressContainer from '../../custom/radial-progress-bar/CaseRadialProgressContainer';
import CaseChartIndicatorComponent from '../../investigation/case/widget/CaseChartIndicatorComponent';
import moment from 'moment/moment';
import Breadcrumb from '../../Breadcrumb';
import Icon from '../../../icons/Icon';
import { store } from '../../../redux/store';
import { initialPagePath } from '../../../redux/reducers/PageReducer';
import ComponentName from '../../../constant/ComponentName';
import FolderService from '../../../service/FolderService';
import LanguageUtil from '../../../util/LanguageUtil';

class WatchlistSocialMediaComponent extends Component<Props, State> {
  public state: State = new State();
  private watchlistService: WatchlistService = ServiceContainer.getInstance().get(ServiceNames.WATCHLIST);

  render() {
    const { customerData, customerLoading, date, email, phone } = this.state;
    return (
      <div className='w-full h-full flex flex-col overflow-y-hidden'>
        <Breadcrumb />
        <div className={'p-5'}>
          <div className={'flex'}>
            <span
              key={'icon'}
              className='w-[60px] h-[60px] min-h-[60px] min-w-[60px] 2xl:w-[80px] 2xl:h-[80px] 2xl:min-h-[80px] 2xl:min-w-[80px] flex justify-center items-center rounded-[50%] bg-[#EFF2FE] mr-1'
            >
              <Icon icon={'socialmediascreening'} className={'hidden w-[22px] h-[22px] 2xl:w-[32px] 2xl:h-[32px]'} color={'#728EFF'} />
            </span>
            <div className={'flex flex-col justify-center pl-3'}>
              <span className={'text-[24px] 2xl:text-4xl font-normal'}>
                {(email == undefined || email.trim().length == 0) && (phone == undefined || phone.trim().length == 0)
                  ? 'Social Media Screening'
                  : `${email} / ${phone}`}
              </span>
              <div className={'flex items-center gap-x-1'}>
                <span
                  className={`flex text-xs shrink-0 2xl:text-md h-full justify-center items-center px-[8px] py-[3px]  rounded-[50px]  bg-[#F6F6F9] text-[#4F4F4F]`}
                >
                  {date}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className={'px-5 text-f-black-2 text-[13px] flex items-center gap-x-1'}>
          <Icon icon={'captive_portal'} size={14} color={'#728EFF'} />
          <span>
            {LanguageUtil.get({
              id: 'pages.watchlist.socialMediaComponent.description',
              defaultMessage: 'You can review the social media on the internet about the person who meets the search criteria below.',
            })}
          </span>
        </div>
        {(email == undefined || email.trim().length == 0) && (phone == undefined || phone.trim().length == 0) ? (
          <div className={'p-5 overflow-y-scroll h-full w-full'}>
            <div className={'w-full h-full flex flex-col items-center justify-center px-4 bg-main-gray border rounded-xl'}>
              <div className={'w-1/3 flex flex-col items-center justify-center gap-y-1'}>
                <img src={'/icons/empty.svg'} alt='empty' className={'w-[120px] h-[120px]'} />
                <span className={'text-black text-[16px]'}>
                  {LanguageUtil.get({ id: 'pages.watchlist.socialMediaComponent.notOccur', defaultMessage: 'Social media scan did not occur' })}
                </span>
                {LanguageUtil.get({
                  id: 'pages.watchlist.socialMediaComponent.notBePerformed',
                  defaultMessage:
                    'Social media scanning could not be performed because you did not enter your email and phone number. To search, enter your email and phone number when searching!',
                })}
                <span className={'underline text-[#458EF7] cursor-pointer'} onClick={this.onClickSearch}>
                  Click to return to the search screen
                </span>
              </div>
            </div>
          </div>
        ) : (
          <div className={'p-5 overflow-y-scroll h-full w-full'}>
            <div className={'grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-5 gap-y-4 gap-x-4 px-4 py-4 w-full bg-[#F9FAFB] border border-[#E0E4E8] rounded-xl'}>
              <div className={'flex col-span-1  lg:grid-cols-1 xl:grid-cols-1 justify-center items-center w-full h-full'}>
                {customerData?.summary.score == undefined && !customerLoading ? (
                  <div
                    className={
                      'flex flex-col items-center gap-y-2 justify-center border-[1px] border-[#E0E4E8] h-full w-full drop-shadow rounded-[8px] bg-white px-3 py-3'
                    }
                  >
                    <img src={'/icons/empty.svg'} alt='empty' className={'w-[80px] h-[80px]'} />
                    <span className={'text-[14px] font-medium pt-2'}>
                      {LanguageUtil.get({ id: 'pages.watchlist.socialMediaComponent.dataNotFound', defaultMessage: 'Data not found' })}
                    </span>
                  </div>
                ) : (
                  <CaseRadialProgressContainer
                    header={LanguageUtil.get({ id: 'pages.watchlist.socialMediaComponent.header', defaultMessage: 'Social Media Score' })}
                    subHeader={LanguageUtil.get({ id: 'pages.watchlist.socialMediaComponent.subHeader', defaultMessage: 'Social Media Scanning Score' })}
                    score={Number(customerData?.summary.score || 0)}
                    progressColor={this.getProgressColor(customerData?.summary.score)}
                    labelColor={this.getLabelColor(customerData?.summary.score)}
                    loading={customerLoading}
                    maxScore={100}
                  />
                )}
              </div>
              <div className={'flex flex-col col-span-1 lg:col-span-1 xl:col-span-2 gap-y-4'}>
                <CaseChartIndicatorComponent
                  icon={'registered-icon-1'}
                  score={`${customerData?.socialMedia.accounts?.filter((socialMedia: any) => socialMedia.status == SocialMediaStatus.FOUND).length || 0} Social Media`}
                  label={LanguageUtil.get({ id: 'common.label.registeredSocialMedia', defaultMessage: 'Registered Social Media' })}
                />
                <CaseChartIndicatorComponent
                  icon={'not-registered-icon-1'}
                  score={`${customerData?.socialMedia.accounts?.filter((socialMedia: any) => socialMedia.status == SocialMediaStatus.NOT_FOUND).length || 0} Social Media`}
                  label={LanguageUtil.get({ id: 'common.label.notRegisteredSocialMedia', defaultMessage: 'Not Registered Social Media' })}
                />
              </div>
              <div className={'flex flex-col col-span-1 lg:col-span-1 xl:col-span-2 gap-y-4'}>
                <CaseChartIndicatorComponent
                  icon={'data-breaches-icon-1'}
                  score={`${customerData?.socialMedia.breaches.length || 0} Data Breaches`}
                  label={LanguageUtil.get({ id: 'common.label.dataBreaches', defaultMessage: 'Data Breaches' })}
                />
                <CaseChartIndicatorComponent
                  icon={'seen-icon-1'}
                  score={customerData?.summary.firstSeen ? moment(customerData?.summary.firstSeen).format('LL') : '-'}
                  label={LanguageUtil.get({ id: 'common.label.firstSeen', defaultMessage: 'First Seen' })}
                />
              </div>
            </div>
            <div className={'py-5'}>
              <WatchlistCustomerComponent customerResponse={customerData} customerLoading={customerLoading} />
            </div>
          </div>
        )}
      </div>
    );
  }

  public async componentDidMount() {
    const { router } = this.props;
    const page = store.getState().page;
    const initial = initialPagePath[ComponentName.WATCHLIST];
    if (page.pagePath.length == 0 || page.pagePath[0].title != initial?.title) {
      await FolderService.calculate('WITHOUT_FOLDER', ComponentName.WATCHLIST, router.location.pathname, store.getState().page);
    }
    const previousSearchParams = new URLSearchParams(router.params.id);
    const email: string | null = previousSearchParams.get('email');
    const phone: string | null = previousSearchParams.get('phone');
    this.setState({ email, phone, date: moment().format('DD/MM/yyyy HH:mm').valueOf() });
    if (email || phone) {
      const body: CustomerRequest = {
        phone: phone,
        email: email,
        hideDetails: false,
        useCache: true,
      };
      try {
        const data = await this.watchlistService.customerLookup(body);
        if (data) {
          this.setState({ customerData: data });
        }
      } catch (e) {
        console.error(e);
      }
    }
    this.setState({ customerLoading: false });
  }

  private onClickSearch = () => {
    const {
      router: { navigate },
    } = this.props;
    navigate('/watchlist');
  };

  private getLabelColor = (score: number | undefined = 0): string => {
    if (score <= 30) {
      return 'text-[#7FCD8C]';
    } else if (score > 30 && score <= 70) {
      return 'text-[#F19E46]';
    } else {
      return 'text-[#D33632]';
    }
  };

  private getProgressColor = (score: number | undefined = 0): string => {
    if (score <= 30) {
      return 'gradient-low';
    } else if (score > 30 && score <= 70) {
      return 'gradient-medium';
    } else {
      return 'gradient-high';
    }
  };
}

interface Props extends FormicaProps {}

class State {
  customerData: WatchlistCustomerDomains | undefined;
  customerLoading: boolean = true;
  email: string | undefined | null;
  phone: string | undefined | null;
  date: string | undefined;
}

export default withFormica(WatchlistSocialMediaComponent);
